
















































import { Component, Vue } from 'vue-property-decorator';
import { TimeAdjustmentEditModel } from '@/services/api/nswag/stapiclient_generated';
import { stTimeAdjustmentApi } from '@/services/st-api';
import SlideIn from '@/components/basic/SlideIn.vue';
import StDurationPicker from '@/components/basic/StDurationPicker.vue';

@Component({
  components: {
    StDurationPicker,
    SlideIn,
  },
})
export default class TimeAdjustmentEdit extends Vue {
  private id: number = 0;
  private timeAdjustment: TimeAdjustmentEditModel = new TimeAdjustmentEditModel();
  private loading: boolean = true;
  private saving: boolean = false;
  private listPage: string = 'TimeAccount';

  openSlideIn() {
    (this.$refs.slideIn as SlideIn).open();
  }

  closeSlideIn() {
    (this.$refs.slideIn as SlideIn).close();
  }

  slideOutClosed() {
    this.$router.push({ name: this.listPage });
  }

  created() {
    this.id = parseInt(this.$route.params.id);
  }

  async mounted() {
    this.openSlideIn();

    const date = this.$route.query.date as string;
    const appUserId = parseInt(this.$route.query.appUserId as string);
    this.timeAdjustment = this.id == 0 ? await stTimeAdjustmentApi.getNew(appUserId, date) : await stTimeAdjustmentApi.get(this.id);
    this.loading = false;
  }

  async deleteTimeAdjustment() {
    if (confirm(this.$t('Die Korrekturbuchung wird gelöscht.').toString())) {
      await stTimeAdjustmentApi.delete(this.id, true);
      this.closeSlideIn();
    }
  }

  async submit() {
    try {
      this.saving = true;
      if (this.timeAdjustment.id == 0) {
        await stTimeAdjustmentApi.post(this.timeAdjustment);
      } else {
        await stTimeAdjustmentApi.put(this.timeAdjustment.id, this.timeAdjustment);
      }
      this.closeSlideIn();
    } finally {
      this.saving = false;
    }
  }
}
